import { UAParser } from 'ua-parser-js';

const UserAgent = {
    setBodyClass() {
        const { browser, cpu, device } = UAParser();
        const classesToAdd = ['loaded'];

        // Browser name
        classesToAdd.unshift(browser.name.replace(' ', '_'));

        // Is mobile
        device.is('mobile') && classesToAdd.push('mobile');

        window.addEventListener('load', () => document.body.classList.add(...classesToAdd));
    }
};

export default UserAgent;
